import { Channel } from 'stream-chat-react';

declare global {
  interface Window {
    client: any;
    ericFeed: any;
    jessicaFlatFeed: any;
    callback: any;
    juleAggregatedFeed: any;
  }
}

export type State = {
  apiKey?: string;
  userId: string;
  userName?: string;
  userToken?: string;
  channelId: string;
  channel: any;
  client: any;
  loading: boolean;
  feedback: any;
  message: any;
  reaction: any;
  response: any;
  listening: any;
  event: any;
};

export enum Actions {
  SetLoading = 'setLoading',
  SetClientUser = 'setClientUser',
  SetClient = 'setClient',
  SetChannel = 'setChannel',
  SetFeedback = 'setFeedback',
  ClearFeedback = 'clearFeedback',
  SetError = 'setError',
  SendMessage = 'sendMessage',
  AddReaction = 'addReaction',
  StartListening = 'startListening',
  NewEvent = 'newEvent',
}

export type Action =
  | { type: Actions.SetLoading; loading: boolean }
  | {
      type: Actions.SetClientUser;
      apiKey: string;
      userId: string;
      userName: string;
      userToken: string;
    }
  | {
      type: Actions.SetClient;
      client: any;
    }
  | { type: Actions.SetChannel; channel: any }
  | { type: Actions.SetFeedback; feedback: { type: string; msg: string } }
  | { type: Actions.ClearFeedback }
  | { type: Actions.SetError; error: any }
  | { type: Actions.SendMessage; message: any }
  | { type: Actions.AddReaction; reaction: any }
  | { type: Actions.StartListening }
  | { type: Actions.NewEvent; event: any };
